import React from 'react'
const About = () => {
  const images = [require('../statics/Gokul.png')]
  return (
    <div className="grid md:grid-cols-2 gap-2 bg-yellow-100 py-32">
      <div className="relative flex items-center justify-center md:col-span-1 sm:mb-12 mb-0 rounded-md h-auto md:h-64 lg:h-auto">
        <div className="w-1/2 z-10">
          <img
            className="md:rounded-lg rounded-full overflow-hidden"
            src={images[0]}
            alt="gokul-varadan-profile"
          />
        </div>
        {/* <div className="w-1/2 z-0 absolute h-full m-4 border-dashed md:rounded-lg rounded-full overflow-hidden border-2 border-yellow-400"></div> */}
      </div>
      <div className="md:col-span-1 flex flex-col md:items-start md:mb-20 items-center justify-center">
        <h1 className="text-2xl md:text-4xl font-bold mt-10 md:mt-10 mb-5 font-heavy">
          About
        </h1>
        <p className="text-lg md:text-xl w-8/12 text-center md:text-left font-light tracking-normal mb-5">
          I'm currently working as a Full Stack Developer at LeagueX. I have a
          passion for building Web and Mobile Applications with a knack for
          problem solving and always looking for new challenges to learn and
          grow. I have a strong background with Data Structures & Algorithms in
          Industial Applications.
        </p>
        {/* <p className="font-light mb-2 text-gray-700 flex flex-col"> */}
          <button className="flex bg-yellow-400 mt-2 font-medium rounded-lg hover:bg-yellow-600 hover:shadow-lg text-black font-bold py-3 px-4">
            <a
              href="https://drive.google.com/file/d/1sPDSrzSLbuByavBsy90WFXpNPI3Zlfzo/view?usp=sharing"
              className="flex ml-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Resume
              {/* <svg
                className="ml-2  w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg> */}
            </a>
          </button>
        {/* </p> */}
      </div>
    </div>
  )
}
export default About
